import useClearSchedules from '@/enterprise/data/useClearSchedules';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import { scheduleTimeZone } from './utils';

export interface ClearScheduleWithTimeZone {
  clearTime: string;
  payDate: string;
  isFinalClear: boolean;
  clearTimeInScheduleTimeZone: Date;
  clearTimeDayOfWeekInScheduleTimeZone: string;
}

export interface OfferModalClearSchedules {
  supplierDivisionUuid: string;
  marketUuid: string;
  makerOrganizationUuid: string;
  clearSchedules: ClearScheduleWithTimeZone[];
}

export interface UseOfferModalClearSchedulesOptions {
  takerMarkets: TakerMarket[];
  startDate?: string;
  endDate: string;
}

export const useOfferModalClearSchedules = ({
  takerMarkets,
  startDate,
  endDate,
}: UseOfferModalClearSchedulesOptions) => {
  const { data } = useClearSchedules({ takerMarkets, startDate, endDate });

  return data.map((scheduleByTakerMarket): OfferModalClearSchedules => {
    return {
      ...scheduleByTakerMarket,
      clearSchedules:
        scheduleByTakerMarket.clearSchedules
          ?.filter((cs) => cs.isFinalClear === true)
          .map((cs) => {
            const clearTimeInScheduleTimeZone = new Date(
              new Date(cs.clearTime).toLocaleString('en-US', { timeZone: scheduleTimeZone })
            );
            return {
              ...cs,
              clearTimeInScheduleTimeZone,
              clearTimeDayOfWeekInScheduleTimeZone: clearTimeInScheduleTimeZone.toLocaleString('en-US', {
                weekday: 'long',
              }),
            } satisfies ClearScheduleWithTimeZone;
          }) ?? [],
    };
  });
};
